import {SolrSearchInput} from "../SolrSearchInput.jsx";
import {useEffect, useRef, useState} from "react";
import {futureDate, getDateStringFromInput, isValidDate, pastDate} from "../../services/date.service.js";
import {getShowMoreText, getURLParams, setURLParams} from "../../services/filter.service.js";
import {getTranslations} from "../../services/language.service.js";

const INITIAL_FILTER = {
    magazines: undefined,
    magazineType: undefined,
    tags: undefined,
    creationDateRange: undefined,
    startDate: undefined,
    endDate: undefined,
    search: undefined
}

export const NewsroomFilter = () => {
    const [filter, setFilter] = useState(Object.assign({}, INITIAL_FILTER, getURLParams()))
    const [facets, setFacets] = useState(undefined)
    const fromInput = useRef()
    const toInput = useRef()
    const [showMoreTags, setShowMoreTags] = useState(false)
    const [showAllTags, setShowAllTags] = useState(false)
    const LANG = getTranslations()
    const [showMobileFilters, setShowMobileFilters] = useState(false)

    useEffect(() => {
        document.addEventListener('facets', (e) => {
            setFacets(e.detail)
        })
        document.addEventListener('facets', () => {
            setFilter(Object.assign({}, INITIAL_FILTER, getURLParams()))
            if (filter.startDate !== undefined) {
                fromInput.current.value = filter.startDate;
            }
            if (filter.endDate !== undefined) {
                toInput.current.value = filter.endDate;
            }
            setTimeout(() => {
                if (filter.search !== undefined) {
                    onSearch(filter.search)
                }
            }, 300)
        }, {once: true})
    }, [])

    useEffect(() => {
        setURLParams(filter)
        document.dispatchEvent(new CustomEvent('filter', {
            detail: filter
        }))
    }, [filter])

    const isFilter = (name, value) => {
        return filter[name] === value
    }

    const toggleFilter = (name, value) => {
        setFilter((current) => {
            return {
                ...current,
                [name]: filter[name] === value ? undefined : value
            }
        })
    }

    const setDate = () => {
        let startDate = undefined;
        let endDate = undefined;
        if (isValidDate(fromInput.current.value)) {
            startDate = fromInput.current.value;
        }
        if (isValidDate(toInput.current.value)) {
            endDate = toInput.current.value;
        }
        setFilter((current) => {
            return {
                ...current,
                startDate: startDate,
                endDate: endDate,
            }
        })
        if (isValidDate(fromInput.current.value) || isValidDate(toInput.current.value)) {
            const from = isValidDate(fromInput.current.value) ? getDateStringFromInput(fromInput.current.value) : pastDate
            const to = isValidDate(toInput.current.value) ? getDateStringFromInput(toInput.current.value, '2359') : futureDate

            setFilter((current) => {
                return {
                    ...current,
                    creationDateRange: `${from}-${to}`
                }
            })
        } else if (filter.creationDateRange !== undefined) {
            setFilter((current) => {
                return {
                    ...current,
                    creationDateRange: undefined
                }
            })
        }
    }

    const onSearch = (search) => {
        filter.search = search;
        setURLParams(filter)
        document.dispatchEvent(new CustomEvent('search', {
            detail: search
        }))
    }

    const onReset = () => {
        document.dispatchEvent(new CustomEvent('reset'))

        fromInput.current.value = ''
        toInput.current.value = ''
        setFilter(INITIAL_FILTER)
        setURLParams(filter)
    }

    const onShowMore = () => {
        if (!showMoreTags) {
            setShowMoreTags(true)
            if (facets && facets.find(f => f.name === 'tags').options.length <= 30) {
                setShowAllTags(true)
            }
            return
        }
        if (!showAllTags) {
            setShowAllTags(true)
            return
        }
        setShowAllTags(false)
        setShowMoreTags(false)
    }

    return <div className={'bg-white aktuar-filter' + `${showMobileFilters ? ' show-mobile-filters' : ''}`}>
        <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="mobile-filter-close"
                aria-label={LANG.close}></button>

        <div>
            <div className="filter-grid">
                <div className="form-group">
                    <div className="headline_4 c-page">{LANG.categories}</div>
                    <div className="filter-tags">
                        {facets && facets.find(f => f.name === 'categories').options.map((option, index) =>
                            <div className="checkbox" key={`category-${index}`}>
                                <label
                                    className={`${isFilter('categories', option.value) ? 'checked' : ''}`}
                                    htmlFor={`newsroom-category-${option.value}`}>
                                    {option.label}
                                    <input
                                        type="checkbox"
                                        id={`newsroom-category-${option.value}`}
                                        checked={isFilter('categories', option.value)}
                                        onChange={() => toggleFilter('categories', option.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                toggleFilter('categories', option.value);
                                            }
                                        }}
                                    />
                                </label>
                            </div>
                        )}
                    </div>
                </div>
                <div className="form-group">
                    <div className="headline_4 c-page">{LANG.freeSearch}</div>
                    <div style={{position: 'relative'}}>
                        <SolrSearchInput filters={{type_textExactS: 10}}
                                         onSelect={e => onSearch(e)} searchvalue={filter.search}></SolrSearchInput>
                    </div>
                </div>
            </div>

            <hr/>

            <div className="filter-grid">
                <div className="form-group">
                    <div className="headline_4 c-page">{LANG.tags}</div>
                    <div className="filter-tags">
                        {facets && facets.find(f => f.name === 'tags').options.map((option, index) => {
                                if (showAllTags || isFilter('tags', option.value) || index < 15 || index < 30 && showMoreTags)
                                    return (
                                        <div className="checkbox" key={`newsroom-tag-${option.value}`}>
                                            <label
                                                className={`${isFilter('tags', option.value) ? 'checked' : ''}`}
                                                htmlFor={`newsroom-tag-${option.value}`}>
                                                {option.label}
                                                <input
                                                    type="checkbox"
                                                    id={`newsroom-tag-${option.value}`}
                                                    checked={isFilter('tags', option.value)}
                                                    onChange={() => toggleFilter('tags', option.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            toggleFilter('tags', option.value);
                                                        }
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    );
                                return null;
                            }
                        )}
                    </div>
                    {(facets && facets.find(f => f.name === 'tags').options.length > 15) &&
                        <button className={'btn btn--icon icon--show' + `${showAllTags ? '-less' : '-more'}`}
                                onClick={onShowMore}>
                            {getShowMoreText(showAllTags, showMoreTags, facets.find(f => f.name === 'tags').options.length)}
                        </button>}
                </div>
                <div className="filter-dates">
                    <div className="headline_4 c-page">{LANG.date}</div>
                    <div className="um-grid--2col">
                        <div className="form-group">
                            <input aria-label={LANG.dateFrom} ref={fromInput} className={`um-form-control`} type="date"
                                   onChange={_ => setDate()}/>
                        </div>
                        <div className="form-group">

                            <input aria-label={LANG.dateUntil} ref={toInput} className={`um-form-control`} type="date"
                                   onChange={_ => setDate()}/>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        <hr/>
        <div className="d-flex justify-end">
            <button className="btn btn--icon icon--refresh" onClick={_ => onReset()}>{LANG.resetFilter}</button>
            <button onClick={() => setShowMobileFilters(!showMobileFilters)}
                    className="btn btn-primary mobile-filter-apply">{LANG.apply}
            </button>
        </div>
        <button onClick={() => setShowMobileFilters(!showMobileFilters)}
                className="mobile-filter-trigger btn bg-primary-dark">Filter
        </button>
    </div>
}
